









import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Errors',
  props: {
    errors: {
      type: Array as () => string[],
      required: false
    }
  }
})

